<template>
  <a :class="`btn btn-${type} btn-${size} btn-${hasLabelClass}`" @click="handleClick" :disabled="disabled">
    <i :class="`fa icon fa-${icon}  icon-label`"  v-if="icon"/>
    &nbsp;{{ label }}&nbsp;
  </a>
</template>
<script>
    export default {
      name: "LteButton",
      props: {
        label: {type: String, default: null },
        url: {type: String, default: '#' },
        type: {type: String, default: 'default' },
        size: {type: String, default: 'xs' },
        icon: {type: String, default: null },
        disabled: {type: Boolean, default: false },
        targetBlank: {type: Boolean, default: false }
      },
      computed:{
        hasLabelClass(){
          if (this.label && this.label.length){
            return "has-label"
          }else{
            return "has-no-label"
          }
        }
      },
      methods: {
        handleClick(){
          if (!this.disabled){
            if (this.url == null || this.url == '#'){
              this.$emit('click')
            }else{
              if (this.targetBlank){
                window.open(this.url, '_blank').focus();
              }else{
                window.location = this.url
              }

            }
          }
        }
      }
    }


</script>